
import { map } from 'rxjs/operators';
import { Injectable, Output, Input, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { DataModel, IDataModel } from './data.model';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { TextSearch } from "../comum/textSearch";


export interface IDocumento extends IDataModel {
    ident: string,
    titulo: string,
    texto:string,
}

@Injectable()
export class Documentos extends DataModel<IDocumento> {
 
    constructor(private db: AngularFirestore) {
        super(db, "documentos");
        this.fVerInativo = false;
    }
    @Input()
    set verInativo(x) {
        this.fVerInativo = x;
        this.snapshotChanges(r=>{
        });
    }
    where(ref) {
        return ref.where('inativo', '==', this.fVerInativo)
          .orderBy("titulo");
    }
    snapshotChanges(proc?) {
        this.reset(
            r => {
                return this.where(r)
            }
        );
        return super.snapshotChanges(proc);
    }
    searchAggr(item) {
        return item.titulo;
    }
    update(id, item, proc?: any, errProc?: any) {
        item.search = TextSearch.decode(this.searchAggr(item));
        return super.update(id, item, proc, errProc);
    }
    gerarNovoCodigo(proc){
        this.getNewID('documento_ident',proc);
    }
    add(item) {
        item.inativo = false;
        item.search = TextSearch.decode(this.searchAggr(item));
        if (item.ident===null) {
        this.gerarNovoCodigo( r => {
            item.ident = r.valor;
            return super.add(item);
            }); } else
        return super.add(item);
}

    searchWhere(w: any, texto: string) {
        TextSearch.encodeWhere(w, 'search.', texto);
    }

    getDocumento(ident: string, proc) {
        let ref = this.db.collection(this.tableNameFull).ref;
        let query = ref.where("ident","==",ident);
        this.openQuery(query,proc);
    }

}
